import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Select from 'react-select';

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: 'none',
    padding: '7px 9px',
    width: '375px'
  })
};

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: 200,
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    margin: '20px 15px',
    flexWrap: 'wrap'
  },
  select: {
    marginBottom: '.5rem'
  },
  priceContainer: {
    margin: '25px 0'
  },
  price: {
    color: '#002380',
    fontSize: 21,
    fontWeight: 'bold',
    margin: '5px 0'
  },
  input: {
    width: 225,
    minHeight: 50,
    padding: 10,
    border: '2px solid #002380',
    borderRadius: '5px',
    fontSize: 15,
    fontWeight: 'bold',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  }
}));

// export const currencyOptions = [
//   { value: 1, label: 'Euros (€)', color: '#00B8D9' },
//   { value: 2, label: 'Dollars ($)', color: '#0052CC' }
// ];

// export const orderOptions = [
//   { value: 1, label: '% of capital raise', color: '#00B8D9' },
//   { value: 2, label: 'Your investment in €', color: '#0052CC' }
// ];

// export const valuationOptions = [
//   { value: 'strike', label: 'Strike', color: '#00B8D9' },
//   { value: 'max-price', label: 'Max price', color: '#0052CC' }
// ];

// export const xxxOptions = [
//   { value: 'xxx', label: 'XXX', color: '#00B8D9' },
//   { value: 'xxx', label: 'XXX', color: '#0052CC' },
//   { value: 'xxx', label: 'XXX', color: '#5243AA' }
// ];

const Step1 = ({
  setOrder,
  setCurrency,
  currencyOptions,
  orderOptions,
  currency,
  order
}) => {
  const classes = useStyles();

  //   const numberWithCommas = (num) => {
  //     return (
  //       <h5 className={classes.price}>{`${
  //         currency
  //       } ${num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}</h5>
  //     );
  //   };

  return (
    <div className={classes.container}>
      <div>
        <Typography className={classes.select} variant="h4">
          Currency
        </Typography>
        <Select
          isClearable
          isSearchable
          defaultValue={currency}
          classNamePrefix="select"
          name="currency"
          options={currencyOptions}
          placeholder="Choose currency"
          styles={customStyles}
          onChange={(e) => setCurrency(e)}
        />
      </div>
      <div>
        <Typography className={classes.select} variant="h4">
          Your order
        </Typography>
        <Select
          isClearable
          isSearchable
          defaultValue={order}
          classNamePrefix="select"
          name="currency"
          options={orderOptions}
          placeholder="Choose your order"
          styles={customStyles}
          onChange={(e) => setOrder(e)}
        />
      </div>
      {/* <div>
        <Typography className={classes.select} variant="h4">
          Valuation
        </Typography>
        <Select
          isClearable
          isSearchable
          classNamePrefix="select"
          name="currency"
          options={valuationOptions}
          placeholder="Choose your valuation"
          styles={customStyles}
          onChange={(e) => setValuation(e)}
        />
      </div> */}
      {/* <div>
        <Typography className={classes.select} variant="h4">
          XXX
        </Typography>
        <Select
          isClearable
          isSearchable
          classNamePrefix="select"
          name="currency"
          options={xxxOptions}
          placeholder="Choose xxx"
          styles={customStyles}
          onChange={(e) => setXxx(e)}
        />
      </div> */}
      {/* <div className={classes.priceContainer}>
        <Typography className={classes.select} variant="h4">
          Price
        </Typography>

        <input
          disabled={!currency}
          className={classes.input}
          name="price"
          type="number"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />
        {price && <span>{numberWithCommas(price)}</span>}
      </div> */}
    </div>
  );
};

export default Step1;
